import {Icon} from './Icon';

/** URLs optionnelles : un lien absent reste masqué plutôt que de pointer nulle part. */
function toolUrl(name: string): string {
  const value: unknown = import.meta.env[name];
  return typeof value === 'string' ? value.trim() : '';
}

export const toolUrls = {
  author: toolUrl('VITE_TOOL_AUTHOR_URL'),
  support: toolUrl('VITE_TOOL_SUPPORT_URL'),
  backoffice: toolUrl('VITE_TOOL_BACKOFFICE_URL'),
};

/** Dit une fois par vue où s'arrête ce portail : l'ACL de contenu reste dans Author. */
export function AuthorBoundary() {
  return <aside className="boundary">
    <strong>Frontière avec Author</strong>
    <p>Ce portail décide qui entre dans chaque outil et avec quel profil. Les droits sur un scénario ou une campagne précis (propriétaire, éditeur, lecteur, partage) se gèrent dans Author, pas ici.</p>
    {toolUrls.author && <a className="link" href={toolUrls.author} target="_blank" rel="noreferrer">Ouvrir la gestion des accès Author <Icon name="ext" size={12} /></a>}
  </aside>;
}
